import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  TextField,
  Checkbox,
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { enGB } from 'date-fns/locale';
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';

import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import launchFormService from "../../../../services/launchForm.service";
import * as Util from "../../../../services/global.service";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import ColumnDialogLaunchForm from "./ColumnDialogLaunchForm";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";

import { find } from 'lodash'

const useStyles = makeStyles({
});


const DefaultForm = (props) => {
  const { open, close, data, oldDataFilter, openSuccessAddDialog, selectLaunchForm } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const [discardDialog, setDiscardDialog] = React.useState(false);
  let [list, setList] = React.useState({});
  const [isProbation, setIsProbation] = React.useState(false)
  const [isSchedule, setIsSchedule] = React.useState(false)
  const [scheduleDate, setScheduleDate] = React.useState(new Date())
  const [scheduleTime, setScheduleTime] = React.useState(new Date())
  const [scheduleDay, setScheduleDay] = React.useState(15)
  const [readOnly, setReadOnly] = React.useState(false)
  const [isAutoStart, setIsAutoStart] = React.useState(false)
  const [cycleType, setCycleType] = React.useState('annual')

  const handleCloseDialog = () => {
    close(false);
  };

  useEffect(() => {
    setReadOnly(false)
    setIsSchedule(false)
    setIsAutoStart(false)
  }, []);

  useEffect(() => {
  }, [isProbation])

  useEffect(() => {
    if (list?.summary) {
      setReadOnly(true)

      if (list?.summary?.filter?.target_type && list?.summary?.filter?.target_type === 'target_group') {
        let evaluate = find(list?.summary?.templates, { is_probation: true })
        setIsProbation(evaluate ? true : false)
      } else {
        setIsProbation(false)
      }

    }
    else {
      setReadOnly(false)

      if (list?.templates && data?.target_type === 'target_group') {
        let evaluate = find(list?.templates, { is_probation: true })
        setIsProbation(evaluate ? true : false)
      } else {
        setIsProbation(false)
      }
    }

    if (list?.summary?.schedule) {
      setIsSchedule(true)

      if (list?.summary?.schedule?.option?.date) setScheduleDate(dayjs(list?.summary?.schedule?.option?.date))
      if (list?.summary?.schedule?.option?.time) setScheduleTime(dayjs('2024-01-01T' + list?.summary?.schedule?.option?.time))
      if (list?.summary?.schedule?.option?.day) setScheduleDay(list?.summary?.schedule?.option?.day)

    } else {
      setIsSchedule(false)
    }

    let is_auto_start = false
    if (list?.summary?.filter) {
      if (list?.summary?.filter?.start_form) is_auto_start = list?.summary?.filter?.start_form
    }



    if (list?.templates?.length > 0) {
      setCycleType(list?.templates[0].cycle_type)
    }

    setIsAutoStart(is_auto_start)


  }, [list])


  useEffect(() => {
    if (open) {
      //console.log('oldDataFilter', oldDataFilter, data)
      if (oldDataFilter?.target_type === "target_group") {
        let datas = {
          journey_id: Util.formatData(oldDataFilter?.journey_id, ""),
          target_type: Util.formatData(oldDataFilter?.target_type, ""),
          target_group: Util.formatData(oldDataFilter?.target_group, ""),
          except_probation: Util.formatData(oldDataFilter?.except_probation, false),
        }
        launchFormService.getPrepare(datas).then((rs) => {
          setList(rs?.data)
        }).catch((error) => {
        })
      } else if (data?.target_type === "specify_employee") {
        let datas = {
          journey_id: Util.formatData(data?.journey_id, ""),
          target_type: Util.formatData(data?.target_type, ""),
          employees: Util.formatData(data?.employees, ""),
          except_probation: Util.formatData(oldDataFilter?.except_probation, false),
        }
        launchFormService.getPrepare(datas).then((rs) => {
          setList(rs?.data)
        }).catch((error) => {

        })
      } else if (Util.formatData(selectLaunchForm, false) !== false) {
        launchFormService.getSummary(selectLaunchForm).then((rs) => {
          setList(rs?.data)
        }).catch((error) => {

        })
      }
    }
  }, [open]);

  let submit = () => {

    let datas = {
      journey_id: Util.formatData(oldDataFilter?.journey_id, ""),
      target_type: Util.formatData(oldDataFilter?.target_type, ""),
      except_probation: Util.formatData(oldDataFilter?.except_probation, false),
      is_schedule: Util.formatData(isSchedule, false),
      start_form: Util.formatData(isAutoStart, false),
    }

    if (data?.target_type === "target_group") datas.target_group = Util.formatData(oldDataFilter?.target_group, "")
    else if (data?.target_type === "specify_employee") datas.employees = Util.formatData(data?.employees, "")

    if (isSchedule) {
      if (isProbation) {

        datas.schedule_day = parseInt(scheduleDay)

      } else {
        datas.schedule_date = dayjs(scheduleDate).format('YYYY-MM-DD')
        datas.schedule_time = dayjs(scheduleTime).format('HH:mm')
      }
    }


    launchFormService.launch(datas).then((rs) => {
      openSuccessAddDialog()
      close(false)
    }).catch((error) => {
    })


    /*
    if (oldDataFilter?.target_type === "target_group") {
      let datas = {
        journey_id: Util.formatData(oldDataFilter?.journey_id, ""),
        target_type: Util.formatData(oldDataFilter?.target_type, ""),
        target_group: Util.formatData(oldDataFilter?.target_group, ""),
        except_probation: Util.formatData(oldDataFilter?.except_probation, false),
      }
      launchFormService.launch(datas).then((rs) => {
        openSuccessAddDialog()
        close(false)
      }).catch((error) => {
      })
    } else if (data?.target_type === "specify_employee") {
      let datas = {
        journey_id: Util.formatData(data?.journey_id, ""),
        target_type: Util.formatData(data?.target_type, ""),
        employees: Util.formatData(data?.employees, ""),
        except_probation: Util.formatData(oldDataFilter?.except_probation, false),
      }
      launchFormService.launch(datas).then((rs) => {
        openSuccessAddDialog()
        close(false)
      }).catch((error) => {

      })
    }
    */
  }

  const handleDiscardChangeConfirm = () => {
    handleDiscardDialog(false)
    submit()
  };
  const handleDiscardDialog = (value) => {
    setDiscardDialog(value)
  };
  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        {Util.formatData(selectLaunchForm, false) === false ? "Summary" : list?.summary?.templates[0]?.is_probation !== true ? "Journey" : "Summary"}
        {Util.formatData(selectLaunchForm, false) !== false ? <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box> : null}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0", "overflow-y": "unset" }}>
        <Box sx={{ display: "flex", flexFlow: "row wrap" }} pb="5px" >
          <Box sx={{ width: "calc(100% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="15px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              Template:<span style={{ paddingLeft: "15px", fontWeight: "400" }}>{Util.formatData(selectLaunchForm, false) === false ? Util.formatData(list?.journey, "-") : Util.formatData(list?.summary?.journey, "-")}</span>
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexFlow: "row wrap" }} pb="5px" >
          <Box sx={{ width: "calc(100% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="15px" whiteSpace="nowrap" textOverflow="ellipsis">
              Total Target: <span style={{ paddingLeft: "15px", fontWeight: "400" }}>{Util.formatData(selectLaunchForm, false) === false ? Util.formatData(list?.total, 0) : Util.formatData(list?.information?.total, 0)}</span>

              {data?.except_probation &&
                <span style={{ marginLeft: 20, fontWeight: "200" }}>({t('admin.label.exceptProbationEmployee')})</span>
              }

            </Typography>


          </Box>

        </Box>

        {(Util.formatData(selectLaunchForm, false) !== false && list?.templates && list?.templates.length > 0 && list?.templates[0]?.is_probation !== true) &&
          <Box sx={{ width: "calc(100% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="20px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              Cycle:<span style={{ paddingLeft: "15px", fontWeight: "400" }}>{Util.formatData(selectLaunchForm, false) === false ? Util.formatData(list?.cycle, "-") : Util.formatData(list?.summary?.cycle, "-")}</span>
            </Typography>
          </Box>
        }

        {cycleType !== "360" &&

          <Box sx={{ display: "flex", flexFlow: "row wrap" }} pb="5px" pt="10px" >
            {(!readOnly || (readOnly && isSchedule)) &&
              <Box sx={{ width: "calc(15% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
                <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="15px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                  Schedule:
                </Typography>
              </Box>
            }

            {!readOnly &&
              <Box sx={{ width: "calc(10% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
                <Checkbox
                  onClick={(e) => { if (!readOnly) setIsSchedule(e.target.checked) }}
                  sx={{ margin: "15px 0 0 0", padding: "0", alignItems: "center" }}
                  checked={isSchedule}
                  disabled={readOnly}
                />
              </Box>
            }



            {(readOnly && isSchedule) &&
              <Box sx={{ width: "calc(50% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
                <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="15px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">

                  {isProbation ? (
                    <>
                      {scheduleDay &&
                        <>
                          {scheduleDay} {t('label.launchScheduleDay')}
                        </>
                      }
                    </>
                  ) : (
                    <>
                      {scheduleDate && <span style={{ marginRight: 10 }}>{dayjs(scheduleDate).format('YYYY-MM-DD')}</span>}
                      {scheduleTime && dayjs(scheduleTime).format('HH:mm')}
                    </>
                  )}
                </Typography>
              </Box>
            }

            {(isSchedule) &&
              <>

                {(!readOnly && !isProbation) &&
                  <>
                    <Box sx={{ width: "calc(25% - 80px)", marginRight: "10px", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>

                      <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <DatePicker
                          slots={{
                            OpenPickerIcon: Calendar
                          }}
                          format="dd/MM/yyyy"
                          defaultValue={scheduleDate}
                          onChange={(newValue) => {
                            setScheduleDate(newValue)
                          }}
                          minDate={new Date()}
                          // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                          inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                          renderInput={(params) => <TextField  {...params}
                            fullWidth
                            sx={{
                              ".MuiOutlinedInput-root": { color: "#404349", },
                            }}
                          // classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                          />
                          }
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box sx={{ width: "calc(20% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                        <TimePicker views={['hours', 'minutes']} format="HH:mm" defaultValue={scheduleTime} onChange={(v) => setScheduleTime(v)} />
                      </LocalizationProvider>
                    </Box>
                  </>
                }



                {(!readOnly && isProbation) &&
                  <>
                    <Box sx={{ width: "calc(15% - 50px)", marginRight: "5px", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>

                      <TextField
                        type="number"
                        size="small"
                        InputLabelProps={{ shrink: true, }}
                        min={1}
                        value={scheduleDay}
                        required
                        onChange={(e) => setScheduleDay(e.target.value)}
                      />
                    </Box>
                    <Box sx={{ width: "calc(70% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>

                      <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="15px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        {t('label.launchScheduleDay')}
                      </Typography>
                    </Box>
                  </>
                }

              </>
            }

          </Box>

        }

        {((!readOnly || (readOnly && isAutoStart)) && cycleType !== "360") &&

          <Box sx={{ display: "flex", flexFlow: "row wrap" }} pb="10px" pt="5px" >
            <Box sx={{ width: "calc(22% - 80px)", ".MuiFormControl-root": { marginTop: "2px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
              <Typography color="#A0A0A0" fontWeight="500" fontSize={16} lineHeight="17.6px" pt="17px" whiteSpace="nowrap" overflow="hidden" >
                {t('label.launchAutoForm')}:
              </Typography>
            </Box>

            <Box sx={{ width: "calc(10% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
              <Checkbox
                onClick={(e) => { if (!readOnly) setIsAutoStart(e.target.checked) }}
                sx={{ margin: "15px 0 0 0", padding: "0", alignItems: "center" }}
                checked={isAutoStart}
                disabled={readOnly}
              />
            </Box>
          </Box>
        }

        <Box sx={{ border: "1px solid #CED4DA", borderRadius: "4px", p: "10px 5px" }}>
          <Box sx={{ background: "#FAFAFA", display: "flex", alignItems: "center", height: "50px", borderBottom: "1px solid #E5E5E5" }}>
            <Typography width="57.03%" pl="20px" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              Template Name
            </Typography>
            <Typography width="21.26%" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              Start Date
            </Typography>
            <Typography width="21.71%" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              End Date
            </Typography>
          </Box>
          <Box sx={{ height: Util.formatData(selectLaunchForm, false) === false ? "calc(100vh - 455px)" : "calc(100vh - 415px)", overflowY: "overlay", }}>
            {Util.formatData(list?.templates, []).length > 0 ? list?.templates.map((row, index) => (
              <ColumnDialogLaunchForm data={row} key={index} />
            ))
              :
              Util.formatData(list?.summary?.templates, []).length > 0 ? list?.summary?.templates.map((row, index) => (
                <ColumnDialogLaunchForm data={row} key={index} />
              ))
                :
                <Box>

                </Box>
            }
          </Box>
        </Box>
        {Util.formatData(selectLaunchForm, false) === false ?
          <Box display="flex" justifyContent="center" pt="30px">
            <Button color="black" variant="outlined" sx={{ width: "115px" }} onClick={handleCloseDialog}>
              <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">Back</Typography>
            </Button>
            <Button color="primary" variant="contained" sx={{ width: "115px", ml: "35px" }} onClick={e => handleDiscardDialog(true)}>
              <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Launch</Typography>
            </Button>
          </Box>
          :
          null}
      </DialogContent>
      <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title="Confirmation of Launch Form" text={`Are you sure to launch “${Util.formatData(selectLaunchForm, false) === false ? Util.formatData(list?.journey, "-") : Util.formatData(list?.summary?.journey, "-")}” form ?`} />
    </Dialog >
  );
};
export default DefaultForm;
